import {noop} from '@github-ui/noop'
import {LinkExternalIcon} from '@primer/octicons-react'
import {useFragment} from 'react-relay'
import {graphql} from 'relay-runtime'

import type {ExternalLinkTemplateRow$key} from './__generated__/ExternalLinkTemplateRow.graphql'
import {IssueTemplateItem} from './IssueTemplateItem'

type ExternalLinkTemplateRowProps = {
  repositoryContactLink: ExternalLinkTemplateRow$key
}

export const ExternalLinkTemplateRow = ({repositoryContactLink}: ExternalLinkTemplateRowProps): React.ReactElement => {
  const data = useFragment(
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    graphql`
      fragment ExternalLinkTemplateRow on RepositoryContactLink {
        about
        url
        name
      }
    `,
    repositoryContactLink,
  )

  return (
    <IssueTemplateItem
      filename={data.name}
      onTemplateSelected={noop}
      name={data.name}
      link={data.url}
      about={data.about}
      externalLink
      trailingIcon={<LinkExternalIcon />}
    />
  )
}

try{ ExternalLinkTemplateRow.displayName ||= 'ExternalLinkTemplateRow' } catch {}